module.exports = __webpack_public_path__ + "static/media/gen_img12.9ed94536.png";